(()=>{'use strict';
 const root=document.getElementById('rage-motion-app');if(!root?.classList.contains('rp-runtime-ready'))return;
 const q=s=>root.querySelector(s),qa=s=>[...root.querySelectorAll(s)],desktop=()=>matchMedia('(min-width:900px)').matches;
 const game=q('#rp-game');let frame=0,lastHeight=0;
 function fitGame(){
  cancelAnimationFrame(frame);frame=requestAnimationFrame(()=>{
   if(!desktop()||game.hidden||document.fullscreenElement||document.querySelector('.rp-expanded-game'))return;
   const arena=game.querySelector('[data-game-panel]:not([hidden]) .rp-lab-arena')||game.querySelector('[data-game-panel]:not([hidden]) canvas');if(!arena)return;
   const bounds=arena.getBoundingClientRect();if(bounds.width<=0)return;
   const height=window.visualViewport?.height||window.innerHeight;
   // Leave the HUD, status and Shopify preview controls reachable. At very short
   // heights keep a usable arena; ordinary document scrolling stays available.
   const space=Math.max(480,Math.min(650,height-220));
   if(Math.abs(space-lastHeight)>1){lastHeight=space;game.style.setProperty('--rp-pc-arena-height',Math.floor(space)+'px');}
  });
 }
 const gameObserver=new MutationObserver(fitGame);gameObserver.observe(game,{attributes:true,attributeFilter:['hidden','data-active-game']});
 qa('.rp-player-settings,.rp-game-settings').forEach(d=>d.addEventListener('toggle',fitGame));
 window.addEventListener('resize',fitGame);document.addEventListener('fullscreenchange',fitGame);document.fonts?.ready.then(fitGame);fitGame();

 // The same immersive viewport is available to Runner and browsers without
 // element fullscreen. Fallback never attempts pointer lock without permission.
 let expanded=null,restoreScroll=0;
 function closeExpanded(){if(!expanded)return;expanded.classList.remove('rp-expanded-game');expanded=null;document.documentElement.classList.remove('rp-game-expanded');window.scrollTo({top:restoreScroll,behavior:'instant'});window.dispatchEvent(new Event('resize'));fitGame();}
 function toggleExpanded(shell){
  if(expanded===shell){closeExpanded();return;}closeExpanded();restoreScroll=window.scrollY;expanded=shell;
  shell.classList.add('rp-expanded-game');document.documentElement.classList.add('rp-game-expanded');
  if(!shell.querySelector('.rp-expand-close')){const close=document.createElement('button');close.type='button';close.className='rp-expand-close';close.textContent='Fermer le plein écran';close.addEventListener('click',closeExpanded);shell.append(close);}
  window.dispatchEvent(new Event('resize'));
 }
 window.rageGameExpand={toggle:toggleExpanded};document.addEventListener('keydown',event=>{if(event.key==='Escape')closeExpanded();});
 const runner=q('#rp-game-runner .rp-game-shell'),runnerFullscreen=document.createElement('button');
 runnerFullscreen.type='button';runnerFullscreen.className='rp-fullscreen-button';runnerFullscreen.dataset.gameFullscreen='runner';runnerFullscreen.textContent='Plein écran';
 runner.querySelector('.rp-game-hud').append(runnerFullscreen);
 runnerFullscreen.addEventListener('click',async()=>{
  if(document.fullscreenElement===runner){await document.exitFullscreen();return;}
  if(!runner.requestFullscreen){toggleExpanded(runner);return;}
  try{await runner.requestFullscreen();}catch{toggleExpanded(runner);}
 });
 document.addEventListener('fullscreenchange',()=>{runnerFullscreen.textContent=document.fullscreenElement===runner?'Quitter le plein écran':'Plein écran';window.dispatchEvent(new Event('resize'));});
 const form=q('#rp-purchase-form');if(!form)return;const sections=[...form.querySelectorAll(':scope > section.rp-checkout-step')];
 let part=1;for(const child of [...form.children]){
  if(child===sections[2])part=2;
  if(!child.matches('.rp-required-legend,.rp-form-errors'))child.dataset.pcPart=String(part);
 }
 const nav=document.createElement('nav');nav.className='rp-pc-checkout-nav';nav.setAttribute('aria-label','Étapes de la simulation');
 nav.innerHTML='<button type="button" data-pc-back hidden>← Coordonnées</button><span data-pc-step-label role="status">1 / 2 · Vos coordonnées</span><button type="button" data-pc-next>Continuer →</button>';
 form.append(nav);
 function showStep(step,focus=false){
  form.dataset.pcStep=String(step);q('[data-pc-back]').hidden=step===1;q('[data-pc-next]').hidden=step===2;
  q('[data-pc-step-label]').textContent=step===1?'1 / 2 · Vos coordonnées':'2 / 2 · Votre confirmation';
  if(focus){const first=form.querySelector('[data-pc-part="'+step+'"] input:not([type=hidden]),[data-pc-part="'+step+'"] h2');if(first){first.tabIndex=first.matches('h2')?-1:first.tabIndex;first.focus({preventScroll:true});}}
 }
 function invalidIn(step){return [...form.querySelectorAll('[data-pc-part="'+step+'"] [required]')].find(el=>!el.disabled&&(!el.validity.valid||!['checkbox','radio'].includes(el.type)&&!el.value.trim()));}
 function next(){
  const invalid=invalidIn(1);if(invalid){invalid.dispatchEvent(new Event('change',{bubbles:true}));invalid.focus({preventScroll:true});return;}
  showStep(2,true);
 }
 q('[data-pc-next]').addEventListener('click',next);q('[data-pc-back]').addEventListener('click',()=>showStep(1,true));
 form.addEventListener('submit',event=>{
  if(!desktop()||window.rageShopify?.live)return;
  if(form.dataset.pcStep==='1'){event.preventDefault();event.stopImmediatePropagation();next();return;}
  if(invalidIn(1))showStep(1);
 },true);
 showStep(1);
})();
